"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _ReviewedDocumentContext = require("../context/ReviewedDocumentContext");
var _FullPageContainer = _interopRequireDefault(require("../components/layout/FullPageContainer"));
var _Message = require("../components/common/Message");
var _ButtonAnchor = _interopRequireDefault(require("../components/common/ButtonAnchor"));
var _jsxRuntime = require("react/jsx-runtime");
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var DownloadButton = (0, _styledComponents.styled)(_ButtonAnchor.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-top: 1rem;\n"])));
var ReviewConfirmationPage = function ReviewConfirmationPage() {
  var _useReviewedDocument = (0, _ReviewedDocumentContext.useReviewedDocument)(),
    reviewDocxBlobUrl = _useReviewedDocument.reviewDocxBlobUrl;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FullPageContainer.default, {
    "data-sentry-element": "FullPageContainer",
    "data-sentry-component": "ReviewConfirmationPage",
    "data-sentry-source-file": "ReviewConfirmationPage.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Message.Message, {
      "data-sentry-element": "Message",
      "data-sentry-source-file": "ReviewConfirmationPage.tsx",
      children: "Document has been reviewed by Dioptra Agent. Would you like to download the reviewed document?"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(DownloadButton, {
      fill: true,
      href: reviewDocxBlobUrl,
      download: "reviewed.docx",
      "data-sentry-element": "DownloadButton",
      "data-sentry-source-file": "ReviewConfirmationPage.tsx",
      children: "Download Reviewed Document"
    })]
  });
};
var _default = exports.default = ReviewConfirmationPage;